import Vue from 'vue'
import App from './App.vue'

import io from 'socket.io-client';
import $ from 'jquery';
import 'vidbaby';

window.io = io;

vidbaby.init('config', $, './vidbaby');

Vue.config.productionTip = false

window.app = new Vue({
  render: h => h(App)
}).$mount('#app');
